import React from 'react';
import {Container, Row, Col} from 'react-grid-system';
import InfoApp from './mainSection/InfoApp';
import SDeskScreenshoot from './mainSection/SDeskScreenshoot';
import HeaderNav from "./mainSection/HeaderNav";

interface States {
}

interface Props {
}

class MainSection extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <section
                className="mainSection">
                <Container>
                    <Row style={{justifyContent: "flex-end"}}>
                        <HeaderNav/>
                    </Row>

                    <section
                        className="infoApp">
                        <Col>
                            <InfoApp/>
                        </Col>
                        <Col>
                            <SDeskScreenshoot/>
                        </Col>
                    </section>
                </Container>
            </section>
        )
    }
}

export default MainSection;
